import * as cookie from "cookie";
import {Cookie} from "set-cookie-parser";
declare global {
    interface Window {
        RequestFileSystem: any
        webkitRequestFileSystem: any
    }
}

/**
 * Tells whether we are in a browser or server.
 */
export function isBrowser(): boolean {
    return typeof window !== "undefined";
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type Dict<T = any> = { [key: string]: T };

/**
 * Create an instance of the Cookie interface
 */
export function createCookie(
    name: string,
    value: string,
    options: cookie.CookieSerializeOptions
): Cookie {
    let sameSite = options.sameSite;
    if (sameSite === true) {
        sameSite = "strict";
    }
    if (sameSite === undefined || sameSite === false) {
        sameSite = "lax";
    }
    const cookieToSet = {...options, sameSite: sameSite};
    delete cookieToSet.encode;
    return {
        name: name,
        value: value,
        ...cookieToSet,
    };
}


/**
 * Compare the cookie and return true if the cookies have equivalent
 * options and the cookies would be overwritten in the browser storage.
 *
 * @param a first Cookie for comparison
 * @param b second Cookie for comparison
 */
export function areCookiesEqual(a: Cookie, b: Cookie) {
    return a.name === b.name;
    // let sameSiteSame = a.sameSite === b.sameSite
    // if (typeof a.sameSite === 'string' && typeof b.sameSite === 'string') {
    //   sameSiteSame = a.sameSite.toLowerCase() === b.sameSite.toLowerCase()
    // }

    // return (
    //   hasSameProperties(
    //     { ...a, sameSite: undefined },
    //     { ...b, sameSite: undefined },
    //   ) && sameSiteSame
    // )
}